import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormSchema } from './form-schema';
import { FormValue } from './form-value';
import { LOGIN_FORM_DEFAULT_SCHEMA } from './login-form-default-schema';

@Component({
  selector: 'labs-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent implements OnChanges {
  @Input()
  formSchema = LOGIN_FORM_DEFAULT_SCHEMA;

  @Input() isLogin = true;

  @Input() isSubmitting: boolean;

  @Output() submitForm: EventEmitter<FormValue> = new EventEmitter();

  form: FormGroup;

  originalOrder = (): number => 0;

  constructor(private fb: FormBuilder) {
    this.setFormGroup(this.formSchema);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formSchema && changes.formSchema.currentValue) {
      this.setFormGroup(changes.formSchema.currentValue);
    }

    changes.isSubmitting && changes.isSubmitting.currentValue
      ? this.form.disable()
      : this.form.enable();
  }

  private setFormGroup(formSchema: FormSchema) {
    const controls: { [key: string]: any } = {};

    for (const key in formSchema) {
      if (formSchema.hasOwnProperty(key)) {
        controls[key] = new FormControl(null, formSchema[key].validators);
      }
    }

    this.form = this.fb.group(controls);
    this.form.updateValueAndValidity();
  }
}
